export const typesReguserall = {
    GET_REGUSERALL_SUCCESS:'GET_REGUSERALL_SUCCESS',
    GET_REGUSERALL_ERROR:'GET_REGUSERALL_ERROR',
    GET_REGUSERALL_BEGIN:'GET_REGUSERALL_BEGIN'
}
